<template>
	<v-card class="exam-coordinator-card" flat>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">Toetsen (coördinator)</span>
			</v-toolbar-title>
		</v-toolbar>

		<v-card-title class="exam-coordinator-filter pa-4 pb-2">
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Filter"
				single-line
				hide-details
				dense
				class="exam-coordinator-filter-field flex-grow-1"
			></v-text-field>
		</v-card-title>

		<v-sheet color="primary" height="8" tile class="exam-coordinator-accent pa-0 ma-0"></v-sheet>

		<v-alert v-if="loadError" type="warning" dense outlined class="mx-4 mt-3 mb-0">
			{{ loadError }}
		</v-alert>

		<v-data-table
			class="exam-coordinator-table"
			:headers="headers"
			:items="data"
			:search="search"
			:loading="loading"
		>
			<template v-slot:item.aanmelding="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-icon
							v-bind="attrs"
							v-on="on"
							style="cursor: pointer"
							color="primary"
							@click="goAanmeldingen(item)"
						>
							mdi-clipboard-account-outline
						</v-icon>
					</template>
					<span>Aanmeldingen (kandidaten)</span>
				</v-tooltip>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

const EXAM_HEADERS = [
	{ text: "", align: "center", sortable: false, value: "aanmelding" },
	{ text: "Examen", value: "tbl_sys_exam_type.name" },
	{ text: "Sector", value: "tbl_sys_sector.name" },
	{ text: "Opleiding", value: "tbl_sys_study.name" },
	{ text: "Klas", value: "tbl_sys_class.name" },
	{ text: "Periode", value: "tbl_sys_periode.name" },
	{ text: "Deelkwalificatie", value: "tbl_sys_subject.name" },
	{ text: "Module", value: "tbl_teacher_subject_class.module" },
	{ text: "Docent", value: "tbl_employee.teacher_name" }
];

export default {
	name: "examCoordinator",
	data() {
		return {
			search: "",
			headers: EXAM_HEADERS,
			data: [],
			loading: false,
			loadError: "",
			user: JSON.parse(localStorage.getItem("user") || "{}")
		};
	},
	created() {
		this.getExam();
	},
	methods: {
		goAanmeldingen(item) {
			if (!item || item.id == null) return;
			this.$router.push({
				path: "/schooladmin/exam_aanmeldingen",
				query: { exam_id: String(item.id) }
			});
		},
		normalizeListPayload(payload) {
			if (payload == null) return [];
			if (Array.isArray(payload)) return payload;
			if (typeof payload === "object") {
				if (Array.isArray(payload.data)) return payload.data;
				if (Array.isArray(payload.records)) return payload.records;
				if (Array.isArray(payload.items)) return payload.items;
				if (Array.isArray(payload.result)) return payload.result;
			}
			return [];
		},
		listRequestParams() {
			var u = this.user || {};
			var params = {};
			if (u.id != null) params.user_id = u.id;
			else if (u.user_id != null) params.user_id = u.user_id;
			return params;
		},
		getExam() {
			var self = this;
			this.loadError = "";
			var params = self.listRequestParams();
			if (params.user_id == null) {
				this.loadError =
					"Geen user_id beschikbaar. Log opnieuw in zodat exam/all_my_study aangeroepen kan worden.";
				this.data = [];
				return;
			}
			this.loading = true;
			ax.get("/exam/all_my_study", { params: params })
				.then(function(response) {
					self.data = self.normalizeListPayload(response.data);
				})
				.catch(function() {
					self.loadError =
						"Ophalen van toetsen is mislukt. Controleer of het endpoint exam/all_my_study met user_id bereikbaar is.";
					self.data = [];
				})
				.finally(function() {
					self.loading = false;
				});
		}
	}
};
</script>

<style scoped>
.exam-coordinator-card {
	border-radius: 4px;
	overflow: hidden;
}
.exam-coordinator-filter {
	align-items: flex-end;
	width: 100%;
}
.exam-coordinator-filter-field {
	max-width: 100%;
}
.exam-coordinator-accent {
	display: block;
	width: 100%;
	min-height: 8px;
	flex: none !important;
	border-radius: 0 !important;
}
.exam-coordinator-table >>> .v-data-table__wrapper {
	border-top: thin solid rgba(0, 0, 0, 0.12);
}
</style>
